import React from 'react';

import { ApolloProvider } from '@trello/graphql';
import { ReduxProvider } from 'app/src/components/ReduxProvider';

export const ComponentWrapper: React.FunctionComponent = ({ children }) => {
  const content = (
    <ApolloProvider>
      <ReduxProvider>{children}</ReduxProvider>
    </ApolloProvider>
  );

  return <div className="js-react-root">{content}</div>;
};
